module.exports = __webpack_public_path__ + "img/KE.d35eb79a.svg";